


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const visitorFormRed = function(state = initialState, action) {
switch (action.type) {
case Actions.VISITOR_FORM_SUB:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.VISITOR_FORM_SUB_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.VISITOR_FORM_SUB_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
